module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAANtJREFUKFOVkrFqAlEQRc+FhQimMI0bK5PO0oAfkfxD+hQpEtDPSGFjYe8/mH9IQMvtjJXRLbTYEMWFCSNuoaC8TDEDj3vue7w7Yl8TKF1WeTZ4RDRkRIixweBnTv8W1i6Vt2WFen7BO9AoDI5mEm24v1ox1c45ZnRGXLBJNudOi5gXQfeE8+Gx0VEa8wG0QgAzxkqrbBFREABrf9KvoBQCYOR+wwjRDALg04E24i0EMHj9/7e68+yam8gYngsuFw+1b752SXt5gOWYJ/lqGE0TuYwEGGQLesVq/AEm00NPVTMqHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/dot-icon-active.png
// module id = gmvJ
// module chunks = 1